export default (baseData) => ({
    init() {
        this.$watch('$store.cart.data', () => {
            this.updateSelectionFromCart()
        })
        this.$watch('selected', () => {
            this.updateValue()
        })
        this.updateSelectionFromCart()
    },
    platform: baseData,
    selected: 'none',
    value: undefined,
     updateValue() {
        if (this.selected === 'none') {
            this.value = {
                id: 'none',
                quantity: '0',
                multiplier: 0
            }
        } else {
            this.value = this.platform.items[this.selected]
        }
    },
    updateSelectionFromCart() {
        for (const item of this.$store.cart.data) {
            if (item.item === this.platform.licenseId) {
                this.selected = item[this.platform.name]
            }
        }
    },
})